import React, { useEffect } from 'react';

import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { useLocation } from 'react-router-dom';

import { pathDictionary } from '../constants';
import { HeaderProps } from '../types/props';
import { capitalize } from '../utils';

import './css/Header.css';

// Create a lowercase version of the path dictionary for case-insensitive lookup
const lowerCasePathDictionary = Object.fromEntries(
  Object.entries(pathDictionary).map(([key, value]) => [
    key.toLowerCase(),
    value
  ])
);

const Header: React.FC<HeaderProps> = ({ setSidebarVisible }) => {
  const location = useLocation();
  const loginUrl = '/login';
  const pathnames = location.pathname.split('/').filter((x) => x);
  const isNotLoginOrSetPass: boolean = pathnames[0]?.toLowerCase() !== 'login' && pathnames[0]?.toLowerCase() !== 'set-password' && pathnames[0]?.toLowerCase() !== 'privacy_policy';

  const items = pathnames.map((value, index) => {
    // Convert the path segment to lowercase for case-insensitive lookup
    const lowerCaseValue = value.toLowerCase();
    const isNumericId = /^\d+$/.test(value);
    const url = `/${pathnames.slice(0, index + 1).join('/')}`;

    const label = isNumericId
      ? 'Карточка наряда'
      : lowerCasePathDictionary[lowerCaseValue] || capitalize(value);

    return { label, url };
  });

  if (isNotLoginOrSetPass) {
    items.unshift({ label: 'Главная страница', url: '/' });
  }

  useEffect(() => {
    if (isNotLoginOrSetPass) {
      const lastItem = items[items.length - 1];
      let pageTitle = 'Дело.Трек';

      if (items.length === 1 && lastItem.label === 'Главная страница') {
        pageTitle = 'Дело.Трек - Главная страница';
      } else if (lastItem.label === 'Карточка наряда') {
        const numericId = pathnames.find(segment => /^\d+$/.test(segment));
        pageTitle = `Дело.Трек - Наряд №${numericId || ''}`;
      } else {
        pageTitle = `Дело.Трек - ${lastItem.label}`;
      }

      document.title = pageTitle;
    } else {
      document.title = 'Дело.Трек';
    };
  }, [location.pathname]);

  return (
    <div className="header wrapper flex align-items-center justify-content-between">
      {isNotLoginOrSetPass && (
        <div className="flex align-items-center header__nav">
          <Button
            className="menu-toggle"
            icon="pi pi-bars"
            onClick={() => setSidebarVisible(true)}
          />
          <BreadCrumb
            model={items}
            className="flex p-menuitem-text header__breadcrumb"
          />
        </div>
      )}
      {location.pathname !== loginUrl && (
        <img
          src="/Delo-Trak_Logo_Color_1.png"
          height={50}
          width={143}
          alt="Логотип Дело.Трек"
          style={{ objectFit: 'contain' }}
        />
      )}
    </div>
  );
};

export default Header;